import React, { useContext, useEffect, useState, useRef } from 'react';
import { AuthContext } from '../../shared/context/auth-context';
import { useForm } from '../../shared/hooks/form-hook';
import Comment from '../../shared/components/FormElements/comment';
import CourseModal from '../../shared/components/UIElements/courseModal';
import Share from '../../shared/components/FormElements/share';
import Like from '../../shared/components/FormElements/like';

import ImageUpload from '../../shared/components/FormElements/imageUpload';
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
// import { MdDeleteOutline } from "react-icons/md";
import './User.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import UserProfile from './userProfile';
import UserModal from '../../shared/components/UIElements/userModal';




const User = () => {
  const auth = useContext(AuthContext)
  const { user, updateUser } = useContext(AuthContext);

  const dropRef = useRef(null);
  const [drop, setDrop] = useState(null);

  const [userPostData, setUserPostData] = useState([]);

  const [open, setOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false); 

  const [ formState, inputHandler ] = useForm(
    { 

      image: {
        value: null,
        isValid: false
      }
    },
    false
  );

  
 
  useEffect(() => {
    const fetchUserPosts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/user/${user.id}`);
        const responseData = await response.json();
        setUserPostData(responseData.posts || []); // Ensure it is array
        setIsLoaded(true);
        console.log(responseData)
      } catch (err) {
        console.log(err.message)
        setIsLoaded(true); // Avoiding infinite loading
      }
    };
  
      fetchUserPosts();
    
    
  }, [user.id]);


  // DELETE POST
  const deleteHandler = async (postId) => {
    const confirm = window.confirm("Are you sure to delete the post!. " , {postId});

    if(!confirm) {
      return
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}`,{
         method: 'DELETE',
         headers: {
          'Authorization': 'Bearer ' + auth.token
        }
      });
 
      if(!response.ok){
        const errorData = await response.json();
        throw new Error('Could not delete the post for provided id. '|| errorData.message)
      }
       
      setUserPostData(prevPost => prevPost.filter(post => post.id !== postId))
    } catch (err) {
      console.log(err.message)
    }
  };


  // Time Format
  const timeHandler = (createdAt) => {
    const now = new Date();
    const postTime = new Date(createdAt);
    const diffInSeconds = Math.floor((now - postTime) / 1000);

    const secInMinute = 60;
    const secInHour = 3600;
    const secInDay = 86400;
    const secInWeek = secInDay * 7;
    const secInMonth = secInDay * 30;

    if (diffInSeconds < secInMinute) {
      return `${diffInSeconds}s`;
    } else if (diffInSeconds < secInHour) {
      const minutes = Math.floor(diffInSeconds / secInMinute);
      return `${minutes}m`;
    } else if (diffInSeconds < secInDay) {
      const hours = Math.floor(diffInSeconds / secInHour);
      return `${hours}h`;
    } else if (diffInSeconds < secInWeek) {
      const days = Math.floor(diffInSeconds / secInDay);
      return `${days}d`;
    } else if (diffInSeconds < secInMonth) {
      const weeks = Math.floor(diffInSeconds / secInWeek);
      return `${weeks}w`;
    } else {
      // After 1 month → display like "12, May"
      return postTime.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short'
      });
    }
  }

  const dropHandler = (postId) => {
    setDrop(drop === postId ? null : postId)
  }
 

  const changeImage = async (e) => {

    e.preventDefault();
        const isConfirmed = window.confirm("Are you sure to change it?");

        if(!isConfirmed){
          console.log("Change the image cancelled! ")
          return;
        };

    setIsLoaded(true);

    const formData = new FormData();
    formData.append('image', formState.inputs.image.value); // Append an image file

    console.log('this is a formState inputs. ', formState.inputs.image.value);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/${user.id}`, {
        method: 'PATCH',
        body: formData,
        
        
      });

      if (!response.ok){
        throw new Error('Failed to update profile image')
      };

      const responseData = await response.json();
  

      updateUser ({ ...user, image: responseData.user.image });
        // updateUser(updatedUser);


      // Update local storage with the new user information
      localStorage.setItem(
        'user',
        JSON.stringify({
          user: { ...user, image: responseData.user.image },
          token: localStorage.getItem('token'), // Make sure the token remains the same
        })
      );
  
    } catch (err) {
      console.log(err.message)
      
    } finally {
      setIsLoaded(false);
    }
  }
 
  
    const handleCourseOpen = (postId) => setOpen(postId);
    const handleCourseClose = () => setOpen(false);
        
    const handleUserOpen = () => setUserOpen(true);
    const handleUserClose = () => setUserOpen(false)


  

  return (
    <main className='userPost__main__container'> 
      <div className='userPost__main__controller'>  

      {/* User Profile section */}
        <section className='user-profile-section'>

          {/* Desktop for user profile*/}
          <h3 style={{textAlign:'center'}}>{user.name}'s Profile</h3>
  
          {isLoaded && 
            <ImageUpload  
              center 
              id='image' 
              onInput={inputHandler} 
              image={`${process.env.REACT_APP_ASSET_URL}/${user.image}` }
              onClick={changeImage}
            />
          }
          <div className='user-profile-container'>
            <div className='user-profile-change'>Change user name </div>
            <div className='user-profile-change'>Change password</div>
            <div className='user-profile-change'> LinkedIn</div>
            <div className='user-profile-change'> Github</div>
          </div>
        </section>

        {/* Mobile user profile*/}
        <div className='user-hidden-name'>
          <Link to='#' style={{textDecoration: 'none'}} onClick={() => handleUserOpen(user)}>
            <div className='user-hidden-img'>
              <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt='u-pic' />
            </div>   
            <h3>{user.name}'s Profile</h3>
          </Link>  
        </div>
      
        <UserModal show={userOpen} onCancel={handleUserClose}>
          <UserProfile user={user}/>
        </UserModal>

        

      {/* User Post section */}
        <section className='userPost_section-two'>
          <h2>{user.name} your posts</h2>

          <div  ref={dropRef}  className='userPost__map__container'> 
            {isLoaded && userPostData.length === 0 ? (
              <div style={{textAlign: 'center'}}>
                You have no posts yet! 
              </div>
              ) : (

              userPostData && userPostData.map((post, index) => (
                <div key={index} className='userPost__map__controller'>  
                  <div className='userPost-creator'>
                    <div className='userPost-creator-controller'>
                      <img src={`${process.env.REACT_APP_ASSET_URL}/${post.creator.image}`} alt='u-pic'/> 

                      <div className='userPost-name-posted'>
                        <div>{post.creator.name}</div> 
                        <div> 
                          {timeHandler(post.createdAt)} 
                        </div>
                      </div> 
                    </div>
                    
                    {/* Drop Delete button */}
                    <div className='userPost-del-container'>
                      <div onClick={() => dropHandler(post.id)} className='userPost-del-controller'>

                        <div className='userPost-del-dots'>
                          <button><PiDotsThreeOutlineVerticalFill fontSize={25} color='gray'/></button>
                        </div>

                        <div className={`userPost-drop ${drop === post.id ? "show" : "hide" }`}>
                          {/* Delete */}
                          <div className='userPost-drop-delete' >                           
                            <button onClick={() => deleteHandler(post.id)}>Delete</button>
                          </div>
                          <div className='userPost-drop-edit'>
                            <button>Edit</button>
                          </div>                         
                        </div>
                      </div>
                    </div>                      
                  </div>   
                
                  <h4>{post.title}</h4>
                  <div className='userPost-image-container'>

                    {post.video ? (
                      <div className='userPost-video-container'>
                        <video controls width='100%' className='userPost-video'>
                          <source 
                            src={`${process.env.REACT_APP_ASSET_URL}/${post.video}`}
                            type={`video/${post.video.split('.').pop()}`}
                          />
                        </video>
                      </div>
                    
                      ) : post.image ? (
                        <div className='userPost-image-controller'>
                          <img src={`${process.env.REACT_APP_ASSET_URL}/${post.image}`} alt='post img' />
                         </div>  
                      ) : null
                    }             
                  </div>    
                  <p>{post.post}</p>

               
                  <div className='post-footer'>
                    {/* Like */}
                    <div className='post-footer-like'>
                      <Like
                        postId={post._id} 
                        initialLikes={post.likes} 
                        isLikedByUser={post.likes.includes(user.id)}
                        className='footer-like'  
                      />
                    </div>
                 
                    {/* Comment */}
                    <div className='post-footer-comment'>
                      <button className='footer-comment' onClick={() => handleCourseOpen(post._id)}><span style={{marginRight: '5px'}}>{post.comments.length}</span>Comment </button>
                      {open === post._id && (
                        <CourseModal show={open} onCancel={handleCourseClose}>
                          <Comment 
                            postId={post.id}
                          />
                        </CourseModal>
                      )}
                    </div>

                    {/* Share */}
                    <div className='post-footer-share'>
                      <Share
                        postId={post._id}
                      />        
                    </div>
                  </div>
                </div>
              )
            ))}
          </div>
        </section>
      </div>
    </main>   
  ) 
}
export default User;

